Creates a new questionnaire.

The `input` must not exceed 56 KiB in length.

This mutation accepts browser tokens that include the `mutate:application-questionnaires` scope.
